// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c075db16","963":"463a96b4"}[chunkId] + ".chunk.js";
};